import { PREFERENCES_ACTION, PREFERENCES_ENDPOINT } from 'modules/training/modules/preferences/constants'
import { getCurrentPreferencesSelect } from 'modules/training/modules/preferences/selectors'
import saveReduxAction from 'modules/redux/actions/save'
import getPathReduxUtil from 'modules/redux/utils/get-path'
import getEndpointTrainingUtil from 'modules/training/utils/get-endpoint'

function savePreferencesAction () {
  return async (dispatch, getState) => {
    const preferences = getCurrentPreferencesSelect(getState())
    if (!preferences) {
      return
    }
    dispatch(saveReduxAction({
      type: PREFERENCES_ACTION.SAVE,
      payload: {
        endpoint: getEndpointTrainingUtil(PREFERENCES_ENDPOINT.PREFERENCES),
        path: getPathReduxUtil(preferences)
      }
    }))
  }
}

export default savePreferencesAction
